import React from "react";
import { Match } from "@/sources/kicker-amateur/types";
import { getKickoffDetails, isFutureMatch } from "@/utils/datetimeUtils";
import { getResult } from "@/helpers/gameHelpers";

interface MatchScoreProps {
  match: Match;
  showHalfTimeScore?: boolean;
}

export function EmptyMatchScore() {
  return (
    <div className="min-w-[4.5rem] h-10 inline-flex items-center px-1 py-1 bg-gray-400-forced text-white-forced rounded-md text-xl font-bold">
      <div className=" w-[2ch] text-center">-</div>
      <div className="mx-0.5">:</div>
      <div className=" w-[2ch] text-center">-</div>
    </div>
  );
}

export function MatchScore({ match, showHalfTimeScore = true }: MatchScoreProps) {
  const { ATeamScore, BTeamScore, CourtRule } = match;
  const isFutureByKickoff = isFutureMatch(match);
  const isFuture = ["pre", "rescheduled"].includes(match.State!);
  const isRunning = ["running"].includes(match.State!);
  const { kickoffTime } = getKickoffDetails(match);

  const hasHalfTimeScore = !!(
    match.ATeamHalfScore != undefined || match.BTeamHalfScore != undefined
  );

  const isRescheduled = match.State === "rescheduled";
  const isCanceled = match.State === "canceled";

  // const isCanceledAndDeclared = false;
  // const isCanceledBefore = false;
  // const isStoppedMidgame = false;
  const isShortly = false;

  const heightClassName = "h-10 group-[.size-lg]/match:h-11"

  function TextState({ children }: { children: React.ReactNode }) {
    return (
      <div className={`min-w-[4.5rem] ${heightClassName} px-2x bg-gray-100 border border-gray-150 rounded-md font-compressed uppercase text-center flex flex-col justify-center group-[.size-lg]/match:text-lg`}>
        {children}
      </div>
    );
  }

  if (CourtRule) {
    return <TextState>Gewertet</TextState>;
  }
  if (isRescheduled) {
    return <TextState>Verlegt</TextState>;
  }
  if (isCanceled) {
    return <TextState>Abgesagt</TextState>;
  }
  // if (isCanceledAndDeclared) {
  //   return <TextState>Annul.</TextState>;
  // }
  // if (isCanceledBefore) {
  //   return <TextState>Abgesagt</TextState>;
  // }
  // if (isStoppedMidgame) {
  //   return <TextState>Unterbr.</TextState>;
  // }

  if (isShortly) {
    return (
      <div className="min-w-[4.5rem]">
        <div className={`w-full ${heightClassName} inline-flex items-center justify-center px-1 py-1 bg-gray-400-forced rounded-md font-compressed text-highlight uppercase group-[.size-lg]/match:text-lg`}>
          in Kürze
        </div>
      </div>
    );
  }

  if (isFuture && isFutureByKickoff) {
    return (
      <div className={`min-w-[4.5rem] ${heightClassName} px-2x bg-gray-100 border border-gray-150 rounded-md text-lg font-condensed text-center flex flex-col justify-center`}>
        <div className="-mt-0.5">{kickoffTime}</div>
        <div className="-mt-0.5 uppercase text-xs group-[.size-lg]/match:text-sm group-[.size-lg]/match:-mt-1 text-gray-200 leading-none font-semibold">
          Uhr
        </div>
      </div>
    );
  }

  return (
    <div className="min-w-[4.5rem]">
      <div
        className={`w-full ${heightClassName} inline-flex items-center justify-center px-1 py-1 bg-gray-400-forced rounded-md text-lg group-[.size-lg]/match:text-xl font-bold font-compressed
         ${
          isRunning ? "text-highlight" : "text-white-forced"
        }`}
      >
        <div className="text-center min-w-[2ch]">{getResult(ATeamScore)}</div>
        <div className="mx-0.5">:</div>
        <div className="text-center min-w-[2ch]">{getResult(BTeamScore)}</div>
      </div>
      {showHalfTimeScore && hasHalfTimeScore ? (
        // <div className="w-full border border-gray-150 rounded-b-md bg-gray-100 text-gray-200 font-compressed font-bold -mt-2 pt-2 leading-tight text-center">
        <div className="w-full text-gray-200 font-compressed font-bold pt-px leading-tight text-center group-[.size-lg]/match:pt-2 @md:group-[.size-lg]/match:pt-1">
          {match.ATeamHalfScore} : {match.BTeamHalfScore}
        </div>
      ) : null}
    </div>
  );
}
